/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import { ClientSDK } from "../lib/sdks.js";
import { Conversations } from "./conversations.js";
export class WingmanClient extends ClientSDK {
    get conversations() {
        return (this._conversations ?? (this._conversations = new Conversations(this._options)));
    }
}
//# sourceMappingURL=sdk.js.map